import React, { useEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

function AccountGettingStarted () {
  const { setPageName } = useOutletContext();

  useEffect(() => {
    setPageName('Configuremos tu cuenta');
  }, []);

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-12">
          <h1>this is the AccountGettingStarted page</h1>
        </div>
      </div>
    </div>

  );
}

export default AccountGettingStarted;